/** Централизованные пути админки (навигация, редиректы). */
export const ADMIN_PATHS = {
    dashboard: "/admin",
    content: "/admin/articles",
    notifications: "/admin/notifications",
    notificationsBroadcast: "/admin/notifications/broadcast",
    clients: "/admin/clients",
    staff: "/admin/staff",
    clientNew: "/admin/clients/new",
    staffNew: "/admin/staff/new",
    chat: "/admin/chat",
    partners: "/admin/partners",
    applications: "/admin/applications",
    catalogSubmissions: "/admin/catalog-submissions",
    sections: "/admin/sections",
} as const;
